if (!customElements.get('bundle-form')) {
  customElements.define(
    'bundle-form',
    class BundleForm extends HTMLElement {
      constructor() {
        super();
        this.submitButton = this.querySelector('.bundle-form__submit') || this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton?.querySelector('span:first-child');
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }
      }

      getVariantIds() {
        const raw = this.dataset.variantIds || '';
        if (!raw.trim()) return [];
        return raw.split(',').map((id) => id.trim()).filter(Boolean);
      }

      handleErrorMessage(errorMessage = false) {
        const wrapper = this.querySelector('.product-form__error-message-wrapper');
        const messageEl = this.querySelector('.product-form__error-message');
        if (!wrapper || !messageEl) return;
        wrapper.hidden = !errorMessage;
        if (errorMessage) messageEl.textContent = errorMessage;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const variantIds = this.getVariantIds();
        if (variantIds.length === 0) return;

        const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.handleErrorMessage(false);
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let lastResponse = null;
        let error = false;

        try {
          for (let i = 0; i < variantIds.length; i++) {
            const formData = new FormData();
            formData.append('id', variantIds[i]);
            formData.append('quantity', 1);
            formData.append('form_type', 'product');
            formData.append('utf8', '✓');

            const isLast = i === variantIds.length - 1;
            if (cartElement && isLast) {
              formData.append(
                'sections',
                cartElement.getSectionsToRender().map((section) => section.id).join(',')
              );
              formData.append('sections_url', window.location.pathname);
              cartElement.setActiveElement(this.submitButton);
            }

            config.body = formData;
            const response = await fetch(window.routes.cart_add_url, config).then((r) => r.json());

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantIds[i],
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              error = true;
              break;
            }
            lastResponse = response;
          }

          if (!error && lastResponse && cartElement) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: lastResponse,
            });
            cartElement.renderContents(lastResponse);
          } else if (!error && lastResponse && !cartElement) {
            window.location = window.routes.cart_url;
          }
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(window.cartStrings?.error || 'Something went wrong');
        } finally {
          this.submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          if (!error) this.submitButton.removeAttribute('aria-disabled');
          if (cartElement && cartElement.classList.contains('is-empty') && lastResponse) {
            cartElement.classList.remove('is-empty');
          }
        }
      }
    }
  );
}
